import { Box, globalTheme } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { ThemeName } from '~/app-theme';
interface DashboardItemsProps {
  isActive: boolean;
}

interface ThemeBadgeProps {
  currentTheme?: ThemeName;
}

export const HeaderBackdropStyled = styled(Box)<ThemeBadgeProps>`
  ${({ theme, currentTheme }) => css`
    height: ${theme.componentStyles.pageHeaderHeight};
    box-shadow: ${theme.componentStyles.boxShadow};
    position: relative;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: ${currentTheme === ThemeName.THEME_DEFAULT ? theme.colors.white : theme.colors.primary[100]};
    opacity: 0.5;
  `};
`;

export const AppHeaderStyled = styled(Box).attrs({
  py: { sm: '200' },
  px: { sm: '400' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    height: ${theme.componentStyles.pageHeaderHeight};
    box-shadow: ${theme.componentStyles.boxShadow};
    position: relative;
    width: 100%;
    z-index: 1;
  `};
`;

export const LogoSectionStyled = styled(Box)`
  width: 90px;
  ${({ theme }) => css`
    & path {
      fill: ${theme.colors.primary[700]};
    }
    & path:nth-child(2) {
      fill: white;
    }
  `}
`;

export const Divider = styled(Box).attrs({
  mr: { sm: '450' },
  ml: { sm: '450' },
})`
  width: 1px;
  height: 20px;
  background-color: ${({ theme }) => theme.colors.grey[200]};
  margin-top: auto;
  margin-bottom: auto;
`;

export const ToolTipTextStyled = styled(Box).attrs({
  p: { sm: '300' },
  justifyContent: { sm: 'center' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.black};
    text-align: center;
    border-radius: ${theme.radii[300]};
    width: ${theme.componentStyles.navBarWidth};
  `}
`;

export const AccountItemStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  mr: { sm: '200' },
})`
  cursor: pointer;
  width: 120px;
  ${({ theme }) => css`
    height: ${theme.componentStyles.pageHeaderHeight};
    background-color: ${theme.colors.white};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    padding: 0 ${theme.spacings[500]};
  `};
`;

export const AccountSectionStyled = styled.div`
  ${({ theme }) => css`
    box-shadow: ${theme.componentStyles.boxShadow};
  `};
  div:last-child {
    border: none;
  }
`;

export const TopMenuSelectedItemStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  mr: { sm: '200' },
  p: { sm: '500' },
})<DashboardItemsProps>`
  ${({ theme, isActive }) => css`
    height: ${theme.componentStyles.pageHeaderHeight};
    border-bottom: ${isActive ? `4px solid  ${theme.colors.primary[700]}` : `4px solid transparent`};
    letter-spacing: ${isActive ? '0px' : '0.5px'};
  `};
`;

export const HelpIconStyled = styled.div`
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin: 0 ${({ theme }) => theme.spacings[450]};
`;

export const ProjectSelectorStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: '164px';
  height: '32px';
  cursor: pointer;
`;

export const AppHeaderRightContainerStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  margin-left: auto;
`;

export const ThemeItemStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
  mr: { sm: '200' },
})`
  cursor: pointer;
  width: 120px;
  ${({ theme }) => css`
    height: ${theme.componentStyles.pageHeaderHeight};
    background-color: ${theme.colors.white};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    padding: 0 ${theme.spacings[400]};
  `};
`;

export const ThemeColorBadge = styled(Box).attrs({
  mr: { sm: '300' },
})`
  ${({ theme }) => css`
    width: ${theme.spacings[300]};
    height: ${theme.spacings[600]};
    border-radius: ${theme.radii[400]};
    ${getBadgeBackgroundColor}
  `};
`;

const getBadgeBackgroundColor = (props: ThemeBadgeProps) => {
  switch (props?.currentTheme) {
    case ThemeName.THEME_BLUE:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
    case ThemeName.THEME_GREEN:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    case ThemeName.THEME_ORANGE:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[500]};
      `;
    case ThemeName.THEME_RED:
      return css`
        background-color: ${({ theme }) => theme.colors.red[500]};
      `;
    case ThemeName.THEME_PURPLE:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[500]};
      `;
    case ThemeName.THEME_YELLOW:
      return css`
        background-color: ${({ theme }) => theme.colors.yellow[500]};
      `;
    case ThemeName.THEME_DEFAULT:
      return css`
        background-color: ${globalTheme.colors.primary[700]};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.primary[700]};
      `;
  }
};
